import AntSteps, { StepsProps } from 'antd/lib/steps';
import React from 'react';

import cn from 'classnames';
import styles from './Steps.module.scss';

import { Step } from './Step';

export interface IStepsProps extends StepsProps {}

type TSteps = React.FC<IStepsProps> & {
  Step: typeof Step;
};

/**
 * Steps component
 */
export const Steps: TSteps = ({ className, ...restProps }) => (
  <AntSteps className={cn(styles.Steps, className)} {...restProps} />
);

Steps.Step = Step;
